import Alert from "../../../../src/components/Alert";
import * as React from 'react';
export default {
  Alert,
  React
};